
import React from 'react';
import { Link } from 'react-router-dom';

const PropertyTypes: React.FC = () => {
  const propertyTypes = [
    {
      icon: 'ri-plant-line',
      title: '山林・原野',
      description: '管理が困難な山林や原野。固定資産税や草刈り費用の負担から解放されたい方へ。',
      features: ['境界不明でも対応可能', '遠方の土地も対応', '相続土地国庫帰属制度の活用'],
      link: '/blog/sanrin-syobun-5-houhou',
      linkText: '山林処分の方法を見る'
    },
    {
      icon: 'ri-seedling-line',
      title: '農地（田・畑）',
      description: '農地法の規制で売却が難しい農地。農業委員会への対応も含めてサポートします。',
      features: ['農地法の規制に対応', '農業委員会との交渉代行', '転用・国庫帰属の検討'],
      link: '/nouchi',
      linkText: '農地処分の詳細を見る'
    },
    {
      icon: 'ri-home-5-line',
      title: '老朽化した戸建て',
      description: '築年数が古く買い手がつかない戸建て。解体費用の問題も含めて解決策を提案します。',
      features: ['解体費用の検討', '土地としての処分', '相続土地国庫帰属制度'],
      link: null,
      linkText: null
    },
    {
      icon: 'ri-group-line',
      title: '共有名義・相続未分割',
      description: '共有者との調整が難しい不動産。共有物分割請求など法的手続きで解決します。',
      features: ['共有者との交渉代行', '共有物分割請求', '遺産分割協議のサポート'],
      link: '/kyoyu-meigi',
      linkText: '共有名義の解決方法を見る'
    }
  ];

  return (
    <section id="property-types" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-medium mb-4">
            対応可能な不動産
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            こんな不動産の処分に対応しています
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            一般的な不動産会社では扱いにくい物件も、法的手続きを活用して処分をサポートします
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {propertyTypes.map((type, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                  <i className={`${type.icon} text-amber-600 text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{type.title}</h3>
                  <p className="text-gray-600">{type.description}</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                {type.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <i className="ri-check-line text-green-500"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              {type.link && (
                <Link
                  to={type.link}
                  className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 font-medium transition-colors cursor-pointer"
                >
                  <span>{type.linkText}</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyTypes;
